var _path, _path2, _path3, _path4, _use, _use2, _use3, _use4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSg = function SvgSg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4320 2880"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M0 0h4320v1440H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 1440h4320v1440H0zm1481.678-720a541.5 541.5 0 1 1-1083 0 541.5 541.5 0 1 1 1083 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    d: "M1651.835 720a511.735 511.735 0 1 1-1023.47 0 511.735 511.735 0 1 1 1023.47 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "sg_svg__a",
    fill: "#fff",
    d: "m1007.195 733.064-73.56-56.43-73.542 56.457 28.313-90.994-73.795-56.092 91.06.193 27.934-91.123 27.964 91.113 91.06-.226-73.777 56.119z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sg_svg__a",
    transform: "translate(577.189)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sg_svg__a",
    transform: "translate(288.889 -214.211)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sg_svg__a",
    transform: "translate(108 342.749)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sg_svg__a",
    transform: "translate(469.189 342.749)"
  })));
};
export default SvgSg;